import React from 'react';
import Catch from './CustomErrorTracking';
import { Image } from 'react-bootstrap';
import CClogo from '../Assets/CClogo.png';
import 'react-activity/dist/react-activity.css';
export const ErrorBoundary = Catch((props, error) => {
    const node = (error) ? (
        <div className="error-screen">
            <div style={{ height: "100%", width: "100%", position: 'absolute', overflow: 'hidden' }}><div style={{
                display: 'flex',
                height: "100%",
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
            }}><Image style={{
                alignSelf: 'center',
                width: 150,
                height: 150
            }} src={CClogo} />
                <h3 style={{ fontFamily: "montserrat" }}>Oops!</h3>
                <h4 style={{ fontFamily: "montserrat", textAlign: "center" }}>Something went wrong, Please try again later.</h4>
            </div></div>
        </div>
    )
        :
        (<>{props.children}</>);
    return node;
});
ErrorBoundary.propsTypes = {
    children: React.ReactNode
};
export default ErrorBoundary;